function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  d: "M11.837 10.375L9.5 8.038c-.106-.105-.249-.164-.399-.164H8.72c.647-.827 1.032-1.868 1.032-3C9.75 2.183 7.569 0 4.875 0 2.182 0 0 2.182 0 4.875c0 2.692 2.182 4.874 4.875 4.874 1.132 0 2.173-.384 3-1.031V9.1c0 .15.06.293.165.398l2.337 2.337c.22.22.576.22.794 0l.664-.663c.22-.22.22-.577.002-.797zm-6.962-2.5c-1.657 0-3-1.341-3-3 0-1.657 1.34-3 3-3 1.658 0 3 1.34 3 3 0 1.656-1.34 3-3 3z"
});

var SvgMagnifyingGlass = function SvgMagnifyingGlass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMagnifyingGlass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MagnifyingGlass.e0e4e4b7.svg";
export { ForwardRef as ReactComponent };